import CustomSelect2 from '../customSelect2/CustomSelect2';
import { HeadingDescVsmall } from '../Headings';
import addIcon from '../../assets/images/svg/add.svg';
import './addMember.css';

const members = [
  { label: 'Alyna Butt (You)', value: 'alyna butt (you)' },
  { label: 'Taha', value: 'taha' },
  { label: 'Faizan', value: 'faizan' }
];

function AddMember(props) {
  const { labelText, onClick } = props;
  return (
    <div>
      <HeadingDescVsmall
        text={labelText === '' ? 'Select Profile*' : labelText}
      />
      <div className="addMember">
        <CustomSelect2
          placeholder="Alyna Butt (You)"
          defaultValue={members[0]}
          options={members}
        />
        <button type="button" onClick={onClick}>
          <img src={addIcon} alt="add" />
        </button>
      </div>
    </div>
  );
}

export default AddMember;
